import { getConfig } from "../../../../config/app";

export const BFF_URL = getConfig("bff.cicl");
export const HEADERS = {
  accept: "application/vnd.api+json",
  "Content-Type": "application/vnd.api+json"
};
